import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { colors } from 'kangarootime-ui';
import useHover from '../../../hooks/useHover';
import './IconToolbar.css';

const CustomToolTip = withStyles(theme => ({
  tooltip: {
    fontSize: '1rem'
  }
}))(Tooltip);

const Icon = ({ icon, tooltip, onClick }) => {
  const [isHovered, bind] = useHover();

  return (
    <CustomToolTip title={tooltip} open={isHovered} placement='top'>
      <div {...bind} className='icon-toolbar-icon' onClick={onClick}>
        <i className={`fa ${icon}`} style={{ color: colors.brand_4 }} />
      </div>
    </CustomToolTip>

  );
};

Icon.propTypes = {
  icon: PropTypes.string,
  tooltip: PropTypes.string,
  onClick: PropTypes.func
};

export default Icon;
